import React from 'react'

import { Grid, TextField, Button, Paper, Box, Typography, CircularProgress, LinearProgress } from '@material-ui/core'
import { useMutation } from '@apollo/react-hooks'
import { SIGNUP } from './queries'
import decodeJWT from 'jwt-decode'
import { useHistory, Link } from 'react-router-dom'
import { useStyles } from './styles'
import { toast } from 'react-toastify'
import { validatePassword, validateEmail } from '../../utils/functions'

const TOTAL_FIELDS_REQUIRED = 4

function SignUpPage() {
  const classes = useStyles()
  const [progress, setProgress] = React.useState(0)
  const [name, setName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  const [passwordError, setPasswordError] = React.useState('')
  const [passwordConfirmation, setPasswordConfirmation] = React.useState('')
  const [signUp, { loading, error }] = useMutation(SIGNUP)
  const history = useHistory()

  React.useEffect(() => {
    if(error) {
      toast.error(error.message.split(':')[1])
    }
  }, [error])

  const handleSignUp = () => {
    const variables = {
      name,
      email,
      password,
    }

    signUp({
      variables,
      update(cache, { data: { signUp }}) {
        const token = signUp.token
        if (token) {
          const decodedToken = decodeJWT(token)
          localStorage.setItem('token', token)
          localStorage.setItem('userId', decodedToken.sub)
          history.replace('/admin/surveys')
        }
      }
    })
  }

  const passwordMessage = validatePassword(password, passwordConfirmation)

  React.useEffect(() => {
    let totalFilled = 0

    if (!!name) totalFilled++
    if (!!email) totalFilled++
    if (!!password) totalFilled++
    if (!!passwordConfirmation) totalFilled++

    setProgress(100 * totalFilled / TOTAL_FIELDS_REQUIRED)
  }, [name, email, password, passwordConfirmation])

  React.useEffect(() => {
    if (password) {
      setPasswordError(passwordMessage)
    }
  }, [password, passwordConfirmation])

  React.useEffect(() => {
    if (email) {
      setEmailError(validateEmail(email))
    }
  }, [email])

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '100%' }}
    >
      <Grid item xs={ 10 } md={ 5 } style={{ position: 'absolute', top: '10%' }}>
        <Paper elevation={ 1 } className={ classes.wrapper }>
          <Grid
            container
            justify="center"
            alignItems="center"
          >

            <Grid item xs={ 10 } className={ classes.title }>
              <Box mt={ 2 }>
                <Typography variant="h2" noWrap><b>ISE</b>B3</Typography>
              </Box>
              <Box mt={ 1 }>
                <Typography variant="p" className={ classes.subtitle }>
                  Preencha os campos abaixo para criar o seu cadastro na plataforma!
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={ 10 } justify="center">
              <Box mb={ 3 }>
                <LinearProgress
                  variant="determinate"
                  value={ progress }
                />
              </Box>
            </Grid>

            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                autoFocus
                fullWidth
                value={ name }
                onChange={ event => setName(event.target.value) }
                placeholder="Nome Completo"
              />
            </Grid>
            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                fullWidth
                error={ !!emailError }
                helperText={ emailError }
                placeholder="E-Mail"
                value={ email }
                onChange={ event => setEmail(event.target.value) }
              />
            </Grid>
            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                fullWidth
                value={ password }
                onChange={ event => setPassword(event.target.value) }
                type="password"
                placeholder="Digite a sua senha"
              />
            </Grid>
            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                fullWidth
                error={ !!passwordError }
                helperText={ passwordError }
                placeholder="Confirme a sua senha"
                type="password"
                value={ passwordConfirmation }
                onChange={ event => setPasswordConfirmation(event.target.value) }
              />
            </Grid>
            <Grid
              item
              xs={ password === passwordConfirmation ? 6 : 10 }
              className={ classes.submit }
            >
              <Button
                fullWidth
                onClick={ handleSignUp }
                disabled={
                  !email ||
                  !password ||
                  !passwordConfirmation ||
                  password !== passwordConfirmation ||
                  emailError ||
                  !!passwordMessage
                }
              >
                {
                  loading
                    ? <CircularProgress size={ 25 } />
                    : 'Cadastrar'
                }
              </Button>
            </Grid>

            <Grid item xs={ 10 } className={ classes.loginLinkWrapper }>
              <Link to="/login" className={ classes.loginLink }>
                Ou clique aqui para fazer o login
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default SignUpPage
